module.exports = __webpack_public_path__ + "static/media/logo.a92d9c7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.jpg
// module id = 738
// module chunks = 0